import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Policy"
      lastUpdated="December 2025"
      testid="page-privacy"
    >
      <h2 className="font-display font-bold text-2xl tracking-tight">What we collect</h2>
      <p>
        When you place an order, we collect your <strong>name, email, shipping address, and phone number</strong> (if provided). When you sign up for newsletter updates, we collect your <strong>email address</strong> only. We do <strong>not</strong> store credit card numbers — payments are handled directly by Stripe.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">How we use it</h2>
      <p>We use your information to:</p>
      <ul className="list-disc pl-6 space-y-2 text-[#525252]">
        <li>Fulfill and ship your order</li>
        <li>Send order confirmations and tracking updates</li>
        <li>Respond to your support requests</li>
        <li>If you opted in: send occasional insider notes from Manuel about dating, power, and modern relationships</li>
      </ul>

      <h2 className="font-display font-bold text-2xl tracking-tight">Who we share it with</h2>
      <ul className="list-disc pl-6 space-y-2 text-[#525252]">
        <li><strong>Stripe</strong> — to process payments securely</li>
        <li><strong>Shippo</strong> and our shipping carriers — to deliver your order</li>
        <li>No one else. We do not sell, rent, or trade your information.</li>
      </ul>

      <h2 className="font-display font-bold text-2xl tracking-tight">Cookies & analytics</h2>
      <p>
        The Site uses essential cookies and local storage to remember your cart and preferences (for example, dismissing the newsletter popup). We may also use privacy-respecting analytics to understand aggregate traffic patterns. No personally identifiable information is sold to third parties.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Your rights</h2>
      <p>
        You may request a copy of the data we hold about you, ask us to delete it, or unsubscribe from emails at any time by emailing <a href="mailto:orders@12lawsbook.com" className="underline text-[#D92D20]">orders@12lawsbook.com</a>. We will respond within 30 days.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Children</h2>
      <p>
        The Site is intended for adults. We do not knowingly collect information from anyone under 16.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Security</h2>
      <p>
        We use industry-standard encryption (HTTPS / TLS) and secure storage to protect your information. No system is 100% secure, but we take reasonable steps to safeguard your data.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Changes to this policy</h2>
      <p>
        We may update this policy occasionally. The "Last updated" date at the top reflects the most recent revision.
      </p>
    </LegalLayout>
  );
}
